import { createAction, props } from "@ngrx/store";
import { Statistics } from "./state";

export const getStatistics = createAction("[SNOWFLAKE] GET STATISTICS");
export const getStatisticsSuccess = createAction(
    "[SNOWFLAKE] GET STATISTICS SUCCESS",
    props<{ data: Statistics }>(),
);
export const getStatisticsFailure = createAction(
    "[SNOWFLAKE] GET STATISTICS FAILURE",
    props<{ error: string }>(),
);

export const getStaticStructures = createAction(
    "[SNOWFLAKE] GET STATICSTRUCTURES",
);
export const getStaticStructuresSuccess = createAction(
    "[SNOWFLAKE] GET STATICSTRUCTURES SUCCESS",
    props<{ data: any }>(),
);
export const getStaticStructuresFailure = createAction(
    "[SNOWFLAKE] GET STATICSTRUCTURES FAILURE",
    props<{ error: string }>(),
);
